import { login } from '@el5/native-api'
import { getUniversalToken, getX5IdFromToken } from '@gp/base'
import { makeAutoObservable } from 'mobx'

import { FetchState } from '@/types/enum'

export class CustomerStore {
  token: string | null = null
  x5id: string | null = null
  accessTokenState: FetchState = FetchState.initial

  constructor() {
    makeAutoObservable(this)
  }
  get isAuthorized() {
    return this.token !== null
  }

  public async hasCard() {
    return false
  }

  public async getAccessToken() {
    try {
      this.accessTokenState = FetchState.pending
      const accessToken = await getUniversalToken()

      if (accessToken.token) {
        this.token = accessToken.token
        this.x5id = getX5IdFromToken(accessToken.token)

        this.accessTokenState = FetchState.fulfilled
      } else {
        this.accessTokenState = FetchState.rejected
      }
    } catch {
      this.accessTokenState = FetchState.rejected
    }
  }

  login() {
    return login()
  }
}

export const customerStore = new CustomerStore()
